/** @format */

import {styled, Theme} from '@mui/material/styles';
import {Box, Button} from '@mui/material';

import {ButtonVariantProps, HotspotVariant} from './types';
import {getButtonColor} from './helpers/getButtonColor';

// Общие стили для компонентов HotspotBig и HotspotSmall

export const BgImage = styled('img')(() => ({
  width: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 0,
  maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
  webkitMaskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
}));

export const SubHeaderChip = styled(Box)(({theme}) => ({
  borderRadius: '12px',
  background: theme.palette.semantic_dark?.surface.onSurface,
  height: '24px',
  width: 'max-content',
  padding: theme.spacing(0, 2),
  display: 'flex',
  alignItems: 'center',

  color: theme.palette.semantic_dark?.surface.inverseOnSurface,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
}));

const getSetupButtonHoverColor = (variant: HotspotVariant, theme: Theme): string | undefined => {
  switch (variant) {
    case 'blue':
      return theme.palette.semantic_dark?.primary.hover;
    case 'orange':
      return theme.palette.semantic_dark?.alert.hover;
    default:
      return theme.palette.semantic_dark?.surface.surface3;
  }
};

export const SetupButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'customVariant',
})<ButtonVariantProps>(({theme, customVariant}) => ({
  height: '32px',
  width: '100%',
  padding: theme.spacing(0, 4),
  borderRadius: 0,
  background: getButtonColor(customVariant, theme),

  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',

  '&:hover': {
    background: getSetupButtonHoverColor(customVariant, theme),
  },
}));
